export { FileFrame } from './file-frame';
export type { FileFrameProps } from './file-frame';
